import { useState, FC } from 'react';
import { TextField, Button, Box } from '@mui/material';
import { Clear } from '@mui/icons-material';

interface ITextBlock {
  value: string;
  handleValue: (val: string) => void;
  handleRemove: () => void;
}

export const TextBlock: FC<ITextBlock> = ({ value, handleValue, handleRemove }) => {
  const [isEditing, setEditing] = useState(!!value || false);
  if (isEditing) {
    return (
      <>
        <TextField size="small" label="Text Block" autoComplete="nope" variant="outlined" multiline rows={3} value={value} fullWidth onChange={e => handleValue(e.target.value)} />
        <Box display="flex" justifyContent="flex-end">
          <Button
            color="error"
            startIcon={<Clear />}
            onClick={() => {
              handleRemove();
              setEditing(false);
            }}
          >
            Remove
          </Button>
        </Box>
      </>
    );
  }
  return (
    <Button fullWidth color="primary" variant="contained" onClick={() => setEditing(true)}>
      Add Text Block
    </Button>
  );
};
